import { render, staticRenderFns } from "./OverviewCreate.vue?vue&type=template&id=32d9251e&"
import script from "./OverviewCreate.vue?vue&type=script&lang=js&"
export * from "./OverviewCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports